import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import SVGInline from 'react-svg-inline';
import { useProgramFieldsOptionsQuery } from '../../../hooks/useOptions';
import { LabelWithWrappingContent } from './LabelWithWrappingContent';
import { formatDateRange } from '../../../../utils/stringTransformer';

const briefcaseIcon = require('../../../../images/briefcase-white-grey.svg.raw');

export const ProgramDetails = ({ program }) => {
  const [windowHeight, setWindowHeight] = React.useState(window.innerHeight);
  const theme = useTheme();

  const {data: programFieldsOptions} = useProgramFieldsOptionsQuery();

  const programTypeLabel = React.useMemo(() => {
    if (!program || !program.program_type || !programFieldsOptions) return '';
    const found = programFieldsOptions[program.program_type];
    return found ? found.label : program.program_type;
  }, [program, programFieldsOptions]);

  React.useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Calculate dynamic height: window height minus dialog chrome and other elements
  const dynamicMaxHeight = Math.max(200, windowHeight * 0.4);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 2,
        mb: 2,
        pb: 2,
        px: 2,
        border: '1px solid #e0e0e0',
        borderRadius: 1,
        maxHeight: `${dynamicMaxHeight}px`,
        overflow: 'auto'
      }}
    >
      <div
        style={{ width: 36, height: 36, alignItems: 'center', marginTop: 12 }}
      >
         {program.domain?.svg_icon_url ? (
          <img
            style={{
              background: `#${program?.domain?.color || '494949'}`,
              height: theme.typography.pxToRem(28),
              width: theme.typography.pxToRem(28),
              borderRadius: 4,
              padding: 4
            }}
            src={program?.domain?.svg_icon_url}
          />
        ) : (
          <SVGInline svg={briefcaseIcon} />
        )}
      </div>
      <Box sx={{ flex: 1 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 1,
            mt: 2
          }}
        >
        <Typography
          variant="h5"
          style={{ color: program?.domain?.color || '#494949' }}
        >
          {program.domain_name || 'Vocational Currency'}
        </Typography>
        </Box>
        
        <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
          {program.name}
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1 }}>
          {program.category?.name}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          {programTypeLabel}
        </Typography>
          {program.workshops.map((workshop, i) => ( 
            <Box key={i}>
              <Typography variant="body2" color="text.secondary">
                {workshop.name || `Workshop ${workshop.number}`}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>{`${formatDateRange(workshop.start_time, workshop.end_time)} - ${workshop?.location?.name}`}</Typography>
            </Box>
          ))}
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {program.points} points
        </Typography>

        <LabelWithWrappingContent label="Description:" content={program.description} />
      </Box>
    </Box>
  );
};
